// @ts-check
import { Link } from 'react-router-dom';

const TONE_CLASS = {
  ok: 'text-green-600 dark:text-green-400',
  warn: 'text-amber-600 dark:text-amber-400',
  bad: 'text-red-600 dark:text-red-400',
};

/**
 * Shared frame for a dashboard block: title links to the admin page, headline is the one number to act on.
 * @param {{ title: string, href: string, headline?: { label: string, value: number | string, display?: string, tone?: 'ok' | 'warn' | 'bad' } | null,
 *   state?: 'ready' | 'error' | 'untracked', children?: import('react').ReactNode }} props
 */
export default function BlockCard({ title, href, headline, state = 'ready', children }) {
  // min-w-0 lets the card shrink inside the grid; a chart wider than the card scrolls inside it, never the page.
  return (
    <div className="min-w-0 bg-card p-6 border rounded-lg border-border shadow-sm">
      <Link to={href} className="block hover:opacity-80">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        {state === 'ready' && headline && (
          <p className="mt-2">
            <span className={`text-3xl font-bold ${TONE_CLASS[headline.tone || 'ok']}`}>{headline.display ?? headline.value}</span>
            <span className="ml-2 text-sm text-muted-foreground">{headline.label}</span>
          </p>
        )}
      </Link>
      {state === 'error' && <p className="mt-3 text-sm text-muted-foreground">Couldn't load</p>}
      {state === 'untracked' && <p className="mt-3 text-sm text-muted-foreground">Not tracked yet</p>}
      {state === 'ready' && children && <div className="mt-4 max-w-full overflow-x-auto">{children}</div>}
    </div>
  );
}
